module.exports = __webpack_public_path__ + "img/mobile-screen.bb7c96c2.png";